<template>
    <div>
        <!-- Container per sezioni -->
        <div v-if="isContainer" class="content-container">
            <p :id="`node_${node.id}_${node.type}`" class="mt-1" :class="'h' + indent">{{ node.activeTitle }}</p>
            <!-- Contenuto ricorsivo -->
            <div class="col-12">
                <div v-for="childNode in node.childrens" :key="`${childNode.id}`">
                    <!-- Sezione figlio -->
                    <div v-if="childNode.type == 'section' && !childNode.filtered" class="mt-3 ms-3">
                        <TextTreeNode :node="childNode" :contentTree="contentTree" :key="`${childNode.id}`" is-container
                            :indent="indent + 1" />
                    </div>
                    <!-- Articoli -->
                    <div v-else>
                        <div v-if="contentTree && !contentTree.filtered && childNode.findCurrentVersion">
                            <TextTreeNode v-if="childNode.versions.length > 0" :node="childNode"
                                :version="childNode.findCurrentVersion()" is-article :indent="indent + 1" />
                        </div>
                        <div v-else>
                            <div v-for="version in childNode.versions" :key="version.id + version.filtered">
                                <div v-if="'filtered' in version">
                                    <div v-if="!version.filtered && childNode.type == 'content'" class="d-flex">
                                        <TextTreeNode :node="childNode" :version="version" is-article
                                            :indent="indent + 1" />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Articolo -->
        <div v-else-if="isArticle">
            <RouterLink :to="'/index.html?article=' + node.id + '&version=' + version.id">
                <p :id="`node_${node.id}_${node.type}`" class="mt-2 h4">{{ articleTitle }}</p>
            </RouterLink>
            <div class="ms-2 code-view-content" v-html="sanitize(version.html_content)"></div>
        </div>
    </div>
</template>

<style scoped>
.icon {
    width: 18px;
}
</style>
<style>
.code-view-content>table {
    display: block;
    max-width: calc(100vw - 120px);
    margin-left: auto;
    margin-right: auto;
    overflow-x: auto;
    width: 100%;
    margin-bottom: 1rem;
    color: #212529;
    border-collapse: collapse;
}

.code-view-content>table th,
.code-view-content>table td {
    padding: 0.75rem;
    vertical-align: top;
    border: 1px solid #dee2e6;
}

.code-view-content>table thead th {
    vertical-align: bottom;
    border-bottom: 2px solid #dee2e6;
    background-color: #f8f9fa;
    font-weight: 600;
}

.code-view-content>table tbody tr:nth-of-type(odd) {
    background-color: rgba(0, 0, 0, 0.05);
}

.code-view-content>table tbody tr:hover {
    background-color: rgba(0, 0, 0, 0.075);
}
</style>

<script>
import { ContentTree } from '@/classes/tree';
import { sanitize } from '@/utils/sanitize';

export default {
    name: 'TextTreeNode',
    props: {
        indent: {
            type: Number,
            default: 1
        },
        node: {
            type: Object,
            required: true
        },
        contentTree: {
            type: ContentTree,
            required: false
        },
        version: {
            type: Object,
            required: false
        },
        isContainer: {
            type: Boolean,
            default: false
        },
        isArticle: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            expanded: true
        }
    },
    methods: {
        sanitize(html) {
            return sanitize(html);
        },
    },
    computed: {
        articleLink() {
            if (!this.isArticle || !this.version) return '#'
            return `/index.html?article=${this.node.id}&version=${this.version.id}`
        },
        articleTitle() {
            if (!this.isArticle || !this.version) return ''
            return !this.version.title ? this.node.title : this.version.title
        }
    }
}
</script>
